class DevicePostureCheck {
    constructor() {
        /** init actions and validation for create device posture check form */
        new DevicePostureCheckForm('create_device_posture_check_modal', 'frm-createDevicePostureCheckForm-createDevicePostureCheckForm');
    }
}
window.DevicePostureCheck = DevicePostureCheck;